// src/js-dot/ux/functions/set-overlay-position.ts
import { ClassSwitch } from "@js-dot/ui";
var {
  min: MIN,
  max: MAX
} = Math;
function getRootRect(documentElement) {
  const styles = getComputedStyle(documentElement);
  const width = documentElement.clientWidth + parseInt(styles.marginLeft) + parseInt(styles.marginRight);
  const height = documentElement.clientHeight;
  return {
    width,
    height
  };
}
function setOverlayPosition(documentElement, parentElement, overlayElement, position = ["tl", "bl"]) {
  const {
    width: documentWidth,
    height: documentHeight
  } = getRootRect(documentElement);
  const {
    top,
    left,
    width,
    height
  } = parentElement.getBoundingClientRect();
  const {
    scrollHeight: contextHeight,
    clientWidth: contextWidth
  } = overlayElement;
  const halfWidth = width / 2;
  const centerLeft = left + halfWidth;
  let contextTop = top + height;
  let contextLeft = left + halfWidth;
  const contextBottom = contextTop + contextHeight;
  const contextRight = contextLeft + contextWidth;
  const canLeft = contextRight <= documentWidth;
  const canBottom = contextBottom <= documentHeight;
  const canHorizontalCenter = centerLeft + contextWidth <= documentWidth;
  const classNamePrefix = "dot-overlay_";
  let horizontalClass;
  let verticalClass;
  if (canBottom) {
    verticalClass = "bottom";
  } else {
    verticalClass = "top";
    contextTop = top - contextHeight;
  }
  if (canLeft) {
    horizontalClass = "left";
  } else {
    horizontalClass = "right";
    contextLeft = left - contextWidth + halfWidth;
  }
  if (position.includes("around") || position.includes("t") || position.includes("b")) {
    if (canHorizontalCenter) {
      horizontalClass = "center";
      contextLeft = left + (width - contextWidth) / 2;
    }
  }
  const maxTop = documentHeight - contextHeight;
  contextLeft = MAX(0, contextLeft);
  contextTop = MAX(0, MIN(contextTop, maxTop));
  overlayElement.style.top = contextTop + "px";
  overlayElement.style.left = contextLeft + "px";
  overlayElement.style["zoom"] = "1";
  let parent = parentElement.parentNode;
  while (parent !== documentElement) {
    const zoom = parent?.style["zoom"];
    if (zoom) {
      overlayElement.style["zoom"] = zoom;
      break;
    }
    parent = parent.parentNode;
  }
  ClassSwitch.of(overlayElement).set(classNamePrefix + verticalClass, classNamePrefix + horizontalClass, classNamePrefix + verticalClass + "-" + horizontalClass);
}
export { getRootRect, setOverlayPosition };
